import Image from 'app/Components/Shared/Image/image';
import React , {useEffect ,useState,useMemo,useLayoutEffect} from 'react';
import {connect, useDispatch} from 'react-redux';
import PricePlanSelection from './Steps/PricePlanSelection';
import { setCurrentStep , setMessageData , setSelectedBan, setProcessedSubscriberNo, pushToHistory, getProductsById, setShowPopup , clearHistory, backHistory } from './personalPricePlanBlockSlice';
import GeneralMessage from './Steps/GeneralMessage';
import { PersonalPricePlanStep , messageData , subscriberError } from './constant';
import { TAB_ENUM } from '../../Page/SelfCarePage/Constant';
import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';
import SelectBan from './Steps/SelectBan';
import SelectSubscribers from './Steps/SelectSubscriber';
import ConfirmationPage from './Steps/ConfirmationPage';
import Popup from '../../Shared/Popup/PopUp';
import { isMobile } from 'react-device-detect';
import {showAppLoader, hideAppLoader} from 'app/Components/Shared/Loader/LoaderSlice';
const PersonalPricePlanBlockMain =React.memo ((props) => {
  const { iContent, personalPricePlan  , authentication , CellularSubscriber, isFetchLoginData }  = props;
  const {subscribersList, productsByBan, showPopup, selectedBan , currentStep } = personalPricePlan;
  const { IsContactPerson, IsPrimaryContact , IDNumber ,OtpNumber } = authentication.loginData.userDetails;
  const pricePlans = iContent?.pricePlansContentArea;
  const magicLinkParams = authentication.loginData?.magicLinkParameters;
  

  useEffect(() => {
     if(personalPricePlan.currentStep == PersonalPricePlanStep.Initial || isNullOrEmpty(personalPricePlan.currentStep)){
      if(!isFetchLoginData){  
        showAppLoader();
      }else{
        getProductsById();
      }
    }
  }, [personalPricePlan.currentStep, isFetchLoginData]);

  useEffect(() => {
    return () => {
      props.clearHistory();
    };
  }, []);


  async function getProductsById() {
    await props.getProductsById({idNumber: IDNumber}).then((res) => {
      if(res.payload.data.isSuccess){
        var allCellularBans = res.payload.data.productsByBan.map((p) => p.ban);
            props.setProcessedSubscriberNo(authentication.loginData.userDetails.contactNumber);
            if (isNullOrEmpty(allCellularBans)) {
              props.setMessageData(messageData.NO_CELLULAR_PLAN);
            }else{
              if(IsPrimaryContact){
                  if(allCellularBans.length > 1){
                    if(magicLinkParams && magicLinkParams.ban){
                      props.setSelectedBan(magicLinkParams.ban);
                      props.setCurrentStep(PersonalPricePlanStep.SelectPackage);
                    }else{
                      props.setCurrentStep(PersonalPricePlanStep.SelectBan);
                    }
                  }else{
                    if(subscriberError.isAccountTypeNotValid.checkFunction(res.payload.data.productsByBan[0])){
                      props.setMessageData(messageData.OnlyDisableBan);
                    }else{ 
                      props.setSelectedBan(allCellularBans[0]);
                      props.setCurrentStep(PersonalPricePlanStep.SelectPackage);
                    }
                  }
                }else{
                  var currentBan = getCurrentBan();
                  props.setSelectedBan(currentBan);
                  props.setCurrentStep(PersonalPricePlanStep.SelectPackage);
              }
            }
          }
        });
  }

  const getCurrentBan = () => {
    var currentSubscriber ="";
    if(!isNullOrEmpty(OtpNumber)){
      currentSubscriber=  CellularSubscriber?.find((s) => s.productSubscriberNo == OtpNumber);
    }else{
      currentSubscriber= CellularSubscriber?.[0];
    }
    return currentSubscriber?.ban;
  }


  const getCurrentStep = useMemo(() => {
    window.scrollTo(0, 0);
   if(personalPricePlan.currentStep !== PersonalPricePlanStep.Initial){
    var currentPath = window.location.href.split('#')[1];
    if (personalPricePlan.currentStep !== currentPath) {
        props.pushToHistory(personalPricePlan.currentStep);
      }
    }
    switch (personalPricePlan.currentStep) {
      case PersonalPricePlanStep.SelectPackage:
        return <PricePlanSelection iContent={iContent} />;
      case PersonalPricePlanStep.GeneralMessage:
        return <GeneralMessage />;
      case PersonalPricePlanStep.SelectBan:
        return <SelectBan />;
      case PersonalPricePlanStep.SelectSubscribers:
        return <SelectSubscribers />;
      case PersonalPricePlanStep.SuccessPage:
        return <ConfirmationPage />;
    }

  
  }, [personalPricePlan.currentStep ]);
  

  const displayBackButton = useMemo(() => {
 
    const stepsToIgnoreBackButton = [PersonalPricePlanStep.SuccessPage, PersonalPricePlanStep.SelectBan, PersonalPricePlanStep.Initial , PersonalPricePlanStep.GeneralMessage];
    if((!IsPrimaryContact && personalPricePlan.currentStep === PersonalPricePlanStep.SelectPackage) ||
      stepsToIgnoreBackButton.includes(personalPricePlan.currentStep)
    ){
      return false;
    }else{
      return true;
    }
  }, [personalPricePlan.currentStep]);

  return (
    <div className='personal-price-plan-block'>
         {isMobile && displayBackButton && (
          <div className='back-btn' onClick={() => props.backHistory()}>
            <Image src={require('./icons/back.svg')} alt='back' />
            <span>חזרה</span>
          </div>
         )}
         {getCurrentStep}
         {props.messageData?.isPopup && (
            <Popup className='mainPopup' showPopUp={showPopup} onClose={() => props.setShowPopup(false)}>
                <GeneralMessage />
              </Popup>
        )}
    </div>
    );
}, (prevProps, nextProps) => {
  return (
    prevProps.personalPricePlan.currentStep === nextProps.personalPricePlan.currentStep &&
    prevProps.personalPricePlan.showPopup === nextProps.personalPricePlan.showPopup &&
    prevProps.isFetchLoginData === nextProps.isFetchLoginData
  );
});
const mapStateToProps = (state) => ({
  authentication: state.authentication,
  personalPricePlan: state.personalPricePlan,
  messageData: state.personalPricePlan.messageData,
  CellularSubscriber: state.selfcarePage.subscribersByProduct[TAB_ENUM.Cellular],
  isFetchLoginData: state.selfcarePage?.isFetchLoginData,
});

const mapDispatchToProps = {
  setCurrentStep,
  setMessageData,
  setSelectedBan,
  setProcessedSubscriberNo,
  pushToHistory,
  getProductsById,
  setShowPopup,
  clearHistory,
  backHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonalPricePlanBlockMain);


